import React from "react";
import { Box } from "@mui/material";

const BentoItem = ({ children, colSpan, colStart, sx = {}, ...rest }) => {
  // Only handle colSpan — rowSpan is now handled dynamically by BentoBoxGrid
  const getResponsiveGridValue = (value, start) => {
    if (typeof value === "object" && value !== null) {
      const result = {};
      Object.entries(value).forEach(([breakpoint, v]) => {
        result[breakpoint] = start ? `${start} / span ${v}` : `span ${v}`;
      });
      return result;
    }
    return start ? `${start} / span ${value}` : `span ${value}`;
  };

  const gridStyles = {
    ...(colSpan !== undefined && {
      gridColumn: getResponsiveGridValue(colSpan, colStart),
    }),
    ...sx,
  };

  return (
    <Box sx={{ ...gridStyles, minWidth: 0 }} {...rest}>
      {/* This inner div is what ResizeObserver measures */}
      <Box className="bento-item-inner" sx={{ width: "100%" }}>
        {children}
      </Box>
    </Box>
  );
};

export default BentoItem;
